import Application from '@ember/application'
import Resolver from 'ember-resolver'
import loadInitializers from 'ember-load-initializers'
import config from 'customer-flows/config/environment'
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev'
import '@spinnaker/iliad/dist/components.js'
import '@spinnaker/iliad/dist/iliad.css'
import 'customer-flows/css/main.css'
import '@glint/ember-tsc/types';
import compatModules from '@embroider/virtual/compat-modules'

export default class App extends Application {
  modulePrefix = config.modulePrefix
  Resolver = Resolver.withModules(compatModules)
}

if (config.environment !== 'production') {
  loadDevMessages()
  loadErrorMessages()
}

loadInitializers(App, config.modulePrefix, compatModules)
